import React, { useState } from 'react'
import cx from 'classnames'

import { SessionDataContextProvider, useSession } from '../misc/session_context'
import { Tabs, Tab } from 'lensrentals-components'
import RentalCart from './rental_cart'
import SaleCart from './sale_cart'

import styles from '../../assets/stylesheets/pages/cart/tabs.module.scss'

const CartPage = () => {
  return (
    <SessionDataContextProvider>
      <header className={styles.header}>
        <h1 className={cx('shopping-cart-title', styles['shopping-cart-title'])}>
          Shopping Cart:
        </h1>
      </header>
      <CartTabs />
    </SessionDataContextProvider>
  )
}

const CartTabs = () => {
  const [sessionData] = useSession()
  const rentalCartCount = sessionData.cart?.size
  const saleCartCount = JSON.parse(localStorage.getItem('saleCart'))?.plan?.cart?.reduce((count, item) => count + item.quantity, 0) || 0

  // indexes of tabs
  const RENTAL_CART = 0
  const SALE_CART = 1

  const getInitialActiveTab = () => {
    let queryTab
    if (window && window.location.search) {
      queryTab = new URLSearchParams(window.location.search).get('active')
    }

    if ((rentalCartCount === 0 && saleCartCount > 0) || queryTab === 'sale') {
      return SALE_CART
    } else {
      return RENTAL_CART
    }
  }
  const [activeTab, setActiveTab] = useState(getInitialActiveTab())

  return (
    <Tabs
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      name='cart'
      className={styles.tabs}
    >
      <Tab>
        <Tab.Label>
          Rent {rentalCartCount ? `(${rentalCartCount})` : null}
        </Tab.Label>
        <Tab.Content>
          <RentalCart
            isActive={activeTab === RENTAL_CART}
          />
        </Tab.Content>
      </Tab>
      <Tab>
        <Tab.Label>
          Buy {saleCartCount ? `(${saleCartCount})` : null}
        </Tab.Label>
        <Tab.Content>
          <SaleCart
            isActive={activeTab === SALE_CART}
          />
        </Tab.Content>
      </Tab>
    </Tabs>
  )
}

export default CartPage
